import {
  List,
  Datagrid,
  TextField,
  Edit,
  TextInput,
  Create,
  Show,
  SimpleShowLayout,
  NumberField,
  NumberInput,
  TabbedForm,
  FormTab,
  required,
  minValue,
  FunctionField,
} from 'react-admin';

const coinFilters = [
  <TextInput key="q" source="q" label="Search" alwaysOn />,
  <TextInput key="code" source="code" />,
  <TextInput key="name" source="name" />,
];

// Helper function to safely display JSON objects
const displayJson = (value: any) => {
  if (!value) return '-';
  if (typeof value === 'string') return value;
  try {
    return JSON.stringify(value, null, 2);
  } catch {
    return String(value);
  }
};

export const CoinList = () => (
  <List filters={coinFilters} perPage={25}>
    <Datagrid rowClick="edit" bulkActionButtons={false}>
      <TextField source="uid" label="UID" />
      <TextField source="name" />
      <TextField source="code" />
      <TextField source="coingecko_id" label="CoinGecko ID" />
      <NumberField source="price" options={{ style: 'currency', currency: 'USD' }} />
    </Datagrid>
  </List>
);

export const CoinEdit = () => (
  <Edit>
    <TabbedForm>
      <FormTab label="Basic Info">
        <TextInput source="uid" label="UID" validate={required()} fullWidth />
        <TextInput source="name" validate={required()} fullWidth />
        <TextInput source="code" validate={required()} fullWidth />
        <TextInput source="coingecko_id" label="CoinGecko ID" fullWidth />
        <NumberInput source="price" validate={minValue(0)} fullWidth />
      </FormTab>
      <FormTab label="Details">
        <TextInput source="description" multiline rows={8} fullWidth />
        <TextInput
          source="security"
          multiline
          rows={5}
          fullWidth
          helperText="Security information (JSON)"
          format={(v) => v && typeof v === 'object' ? JSON.stringify(v, null, 2) : v}
          parse={(v) => {
            try {
              return v ? JSON.parse(v) : null;
            } catch {
              return v;
            }
          }}
        />
      </FormTab>
      <FormTab label="Links">
        <TextInput
          source="links"
          multiline
          rows={8}
          fullWidth
          helperText="Links (JSON format)"
          format={(v) => v && typeof v === 'object' ? JSON.stringify(v, null, 2) : v}
          parse={(v) => {
            try {
              return v ? JSON.parse(v) : null;
            } catch {
              return v;
            }
          }}
        />
      </FormTab>
    </TabbedForm>
  </Edit>
);

export const CoinCreate = () => (
  <Create>
    <TabbedForm>
      <FormTab label="Basic Info">
        <TextInput source="uid" label="UID" validate={required()} fullWidth />
        <TextInput source="name" validate={required()} fullWidth />
        <TextInput source="code" validate={required()} fullWidth />
        <TextInput source="coingecko_id" label="CoinGecko ID" fullWidth />
        <NumberInput source="price" validate={minValue(0)} fullWidth />
      </FormTab>
      <FormTab label="Details">
        <TextInput source="description" multiline rows={8} fullWidth />
        <TextInput
          source="security"
          multiline
          rows={5}
          fullWidth
          helperText="Security information (JSON)"
          format={(v) => v && typeof v === 'object' ? JSON.stringify(v, null, 2) : v}
          parse={(v) => {
            try {
              return v ? JSON.parse(v) : null;
            } catch {
              return v;
            }
          }}
        />
      </FormTab>
      <FormTab label="Links">
        <TextInput
          source="links"
          multiline
          rows={8}
          fullWidth
          helperText="Links (JSON format)"
          format={(v) => v && typeof v === 'object' ? JSON.stringify(v, null, 2) : v}
          parse={(v) => {
            try {
              return v ? JSON.parse(v) : null;
            } catch {
              return v;
            }
          }}
        />
      </FormTab>
    </TabbedForm>
  </Create>
);

export const CoinShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="uid" label="UID" />
      <TextField source="name" />
      <TextField source="code" />
      <TextField source="coingecko_id" label="CoinGecko ID" />
      <NumberField source="price" options={{ style: 'currency', currency: 'USD' }} />
      <FunctionField
        label="Description"
        render={(record: any) => (
          <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
            {displayJson(record.description)}
          </pre>
        )}
      />
      <FunctionField
        label="Security"
        render={(record: any) => (
          <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
            {displayJson(record.security)}
          </pre>
        )}
      />
      <FunctionField
        label="Links"
        render={(record: any) => (
          <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
            {displayJson(record.links)}
          </pre>
        )}
      />
    </SimpleShowLayout>
  </Show>
);
